import type { FC, SVGProps } from 'react'

export const Verified: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.66748 16.9575C3.92178 16.2118 4.41621 14.6475 4.03525 13.7315C3.6543 12.8156 2.19531 12.0132 2.19531 11C2.19531 9.98682 3.63809 9.2168 4.03525 8.26846C4.43242 7.32012 3.92178 5.78818 4.66748 5.04248C5.41318 4.29678 6.97754 4.79121 7.89346 4.41025C8.80938 4.0293 9.61182 2.57031 10.625 2.57031C11.6382 2.57031 12.4082 4.01309 13.3565 4.41025C14.3049 4.80742 15.8368 4.29678 16.5825 5.04248C17.3282 5.78818 16.8338 7.35254 17.2147 8.26846C17.5957 9.18438 19.0547 9.98682 19.0547 11C19.0547 12.0132 17.6119 12.7832 17.2147 13.7315C16.8176 14.6799 17.3282 16.2118 16.5825 16.9575C15.8368 17.7032 14.2725 17.2088 13.3565 17.5897C12.4406 17.9707 11.6382 19.4297 10.625 19.4297C9.61182 19.4297 8.8418 17.9869 7.89346 17.5897C6.94512 17.1926 5.41318 17.7032 4.66748 16.9575Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1914 9.05469L9.4335 13.5938L7.05859 11.3242"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const VerifiedFilled: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.30261 11.5321C2.79949 11.029 3.13308 9.97351 2.87605 9.35554C2.61902 8.73757 1.63464 8.19617 1.63464 7.51257C1.63464 6.82898 2.60808 6.30945 2.87605 5.6696C3.14402 5.02976 2.79949 3.99617 3.30261 3.49304C3.80574 2.98992 4.86121 3.32351 5.47918 3.06648C6.09714 2.80945 6.63855 1.82507 7.32214 1.82507C8.00574 1.82507 8.52527 2.79851 9.16511 3.06648C9.80496 3.33445 10.8385 2.98992 11.3417 3.49304C11.8448 3.99617 11.5112 5.05164 11.7682 5.6696C12.0253 6.28757 13.0096 6.82898 13.0096 7.51257C13.0096 8.19617 12.0362 8.7157 11.7682 9.35554C11.5003 9.99539 11.8448 11.029 11.3417 11.5321C10.8385 12.0352 9.78308 11.7016 9.16511 11.9587C8.54714 12.2157 8.00574 13.2001 7.32214 13.2001C6.63855 13.2001 6.11902 12.2266 5.47918 11.9587C4.83933 11.6907 3.80574 12.0352 3.30261 11.5321Z"
      fill="currentColor"
    />
    <path
      d="M9.72852 6.20032L6.51836 9.26282L4.91602 7.73157"
      stroke="white"
      strokeWidth="0.77"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
